<template>
  <div :class="$style.dropdownContainer"
       @click="toggleDropdown">
    <div :class="$style.dropdownTitle">
      <slot name="dropdownTitle" />
    </div>
    <span :class="getDropdownButtonStyle">
      <app-svg-icon name="ic_expand" />
    </span>
    <div :class="getDropdownStyle" :style="{ backgroundColor: color, boxShadow: boxShadow }">
      <slot name="dropdownContent" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true,
    },
    boxShadow: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      dropdownActive: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.dropdownActive = !this.dropdownActive;
    },
  },
  computed: {
    getDropdownStyle() {
      if (this.dropdownActive) {
        return [this.$style.dropdown, this.$style.active];
      }

      return this.$style.dropdown;
    },
    getDropdownButtonStyle() {
      if (this.dropdownActive) {
        return [this.$style.dropdownBtn, this.$style.dropdownBtnActive];
      }

      return this.$style.dropdownBtn;
    },
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.dropdownContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 24px;
  position: relative;
  cursor: pointer;

  .dropdownTitle {
    max-width: 100%;
    padding-left: 7px;
    margin-right: 10px;
    overflow-x: hidden;
    font-size: 1.7rem;

    div {
      font-size: 1.4rem;
    }
  }

  .dropdownBtn {
    cursor: pointer;
    transition: all 0.25s ease-in-out;

    &.dropdownBtnActive {
      transform: rotateX(180deg);
    }
  }
}

.dropdown {
  position: absolute;
  top: calc(100% + 3px);
  left: 0;
  width: 100%;
  padding: 22px 24px;
  z-index: 10;
  cursor: pointer;
  transform: scaleY(0);
  transform-origin: top;
  transition: all 0.2s ease-out;
  height: 0;

  &.active {
    height: auto;
    transform: scaleY(1);
    transition: all 0.2s ease-in;
  }
}
</style>
